/**
 * Utility which computes whether a target window and {@link window.top} conform to the same origin policy.
 *
 * @description If they do, then they share JavaScript execution contexts.
 * @description If they do not, they are the traditional cross-origin `iframe` and host.
 *
 * @param window
 * @returns true if same origin, false if not - if true, then {@link window.top} must be defined.
 */
export var isSameOrigin = function isSameOrigin(window) {
  try {
    var _window$top;
    return Boolean(window.origin && window.origin === ((_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.origin));
  } catch (_unused) {
    return false;
  }
};

/**
 * Utility which computes whether a given window is the top window.
 * @param window window under analysis
 * @returns true if {@link window.top}, otherwise false
 */
export var isTop = function isTop(window) {
  try {
    return Boolean(window.top && window === window.top);
  } catch (_unused2) {
    return false;
  }
};